export class FileDescriptor {

    public constructor(
        public readonly name: string,
        public readonly size: number
    ) {}
}
